import type { SVGProps } from 'react'
const SolidFacebook = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_26600_29926)">
			<path
				d="M24 12C24 5.37264 18.6274 0 12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24 18.1354 24 12Z"
				fill="#0866FF"
			/>
			<path
				d="M16.7006 15.6672L17.3741 12H13.4544V10.703C13.4544 8.76528 14.2147 8.01984 16.1822 8.01984C16.7933 8.01984 17.2853 8.03472 17.5685 8.06448V4.74048C17.0318 4.59168 15.72 4.4424 14.9597 4.4424C10.9498 4.4424 9.10128 6.33552 9.10128 10.4198V12H6.62688V15.6672H9.10128V23.6467C10.0296 23.8771 11.0002 24 11.9996 24C12.4916 24 12.9778 23.9698 13.4544 23.9122V15.6672H16.7006Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_26600_29926">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
)
export { SolidFacebook }
